import { useQuery } from '@tanstack/react-query';
import { fetchAgreement } from '../services/agreements';
import { agreementKeys } from './agreementKeys';

export function useAgreementQuery(id: string | undefined) {
    return useQuery({
        queryKey: agreementKeys.detail(id ?? ''),
        queryFn: () => fetchAgreement(id!),
        enabled: !!id,
    });
}
